import sensors from "../sensors";

class sensorsUtils {
    static bind(key:string, value: any)
    {
        sensors.bind(key, value)
    }
}

export default sensorsUtils;